class BlockQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.updateQuantityInput()
    }
  }

  updateQuantityInput() {
    // const productForm = this.closest('section').querySelector('block-buy-button');
    // const input = productForm.querySelector('input[name="quantity"]');
    // input.value = this.input.value
    // input.dispatchEvent(new Event('change', { bubbles: true }));
    this.updatePrice()
  }

  updatePrice() {
    this
      .closest('section')
      .querySelector('block-price')
      .updateState({ quantity: Number(this.input.value) })
  }

  getQuantity() {
    return Number(this.input.value)
  }
}

customElements.define('block-quantity-selector', BlockQuantitySelector);